module.exports = __webpack_public_path__ + "media/images/gba/2019/v2/logotipo_positivo-58da313bfb3198b57926b65726a6c31f.svg";